import React, { useState, useRef, useEffect, useCallback } from 'react';
import Webcam from 'react-webcam';
import { BrowserMultiFormatReader } from '@zxing/library';
import { fetchProductData } from '../apis/api';

function BarCodeScanner({ onResult }) {
  const webcamRef = useRef(null);
  const [scanning, setScanning] = useState(true);
  const [error] = useState(null);

  const capture = useCallback(async () => {
    if (!scanning) return;

    try {
      const imageSrc = webcamRef.current.getScreenshot();
      const codeReader = new BrowserMultiFormatReader();
      const result = await codeReader.decodeFromImage(undefined, imageSrc);

      if (result) {
        setScanning(false); // Stop scanning
        const productData = await fetchProductData(result.getText()); // Fetch product data
        onResult(productData);
      }
    } catch (err) {
      // Continue scanning if no barcode is detected
    }
  }, [scanning, onResult]);

  useEffect(() => {
    const interval = setInterval(capture, 1000); // Capture every 1 second
    return () => clearInterval(interval);
  }, [capture]);

  return (
    <div>
      <Webcam ref={webcamRef} screenshotFormat="image/jpeg" />
      {error && <p>{error}</p>}
    </div>
  );
}

export default BarCodeScanner;
